import layoutHeaderAside from '@/layout/header-aside'

const meta = { requiresAuthA: true }

export default {
  path: '/',
  name: 'personal',
  meta,
  component: layoutHeaderAside,
  children: (pre => [
    { path: 'personal/center', name: `${pre}center`, component: () => import('@/pages/personal/center'), meta: { meta, title: '个人信息' } },
    { path: 'personal/message', name: `${pre}message`, component: () => import('@/pages/personal/message'), meta: { meta, title: '消息通知' } },
    { path: 'personal/messageDetail', name: `${pre}messageDetail`, component: () => import('@/pages/personal/messageDetail'), meta: { meta, title: '消息通知详情' } }
  ])('personal-')
}
